import React, { useEffect, useState, useSyncExternalStore } from "react";
import LoginHeader from "../Common/LoginHeader";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import * as myConstList from "../Common/BaseUrl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import { Modal } from "react-bootstrap";
import { ProductName } from "../Common/ProductName";
import { ImageValidation } from "../Validation/ImageValidation";
import { useTransUserBalanceListQuery } from "../../redux/TransactionApi";
import { socket } from "../../utils/socket";
import DepositModal from "../Modals/DepositModal";
import WithdrawalModal from "../Modals/WithdrawalModal";
import INRDepositModel from "../Modals/INRDepositModel";
import INRWithdrawModal from "../Modals/INRWithdrawModal";
import config from "../../utils/config";
import { Decimal_util } from "../../utils/Dec.util";
const { imageUrl } = config;
const baseUrl = myConstList.baseUrl;

const AccountFunction = () => {
  const meta = {
    title: `Crypto Wallet Balance | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const [isDepositModelOpen, setIsDepositModelOpen] = useState(false);
  const [isWithdrawalModelOpen, setIsWithdrawalModelOpen] = useState(false);
  const [disabledInrDeposit, setDisabledInrDeposit] = useState(false);
  const [Withdraw_address, setWithdraw_address] = useState("");
  const [isTransferModelOpen, setIsTransferModelOpen] = useState(false);
  const [isINRDepositModelOpen, setIsINRDepositModelOpen] = useState(false);
  const [depositeInrBtn, setDepositeInrBtn] = useState("block");
  const [disableTransferButton, setDisableTransferButton] = useState(false);
  const [disabledInrWithdrawal, setdisabledInrWithdrawal] = useState(false);
  const [disabledCoinWithdrawal, setDisabledCoinWithdrawal] = useState(false);
  const [getCoinName_withdrawl, setGetCoinName_withdrawl] = useState(false);
  const [hideZeroBalance, setHideZero] = useState(false);
  const [isKycModalOpen, setIsKycModalOpen] = useState(false);
  const [walletBalanceAmount, setWalletBalanceAmount] = useState(0);
  const [balanceOfAmount, setBalanceOfAmount] = useState(0);
  const [balanceOfAmountSpot, setBalanceOfAmountSpot] = useState(0);
  const [spotBalance, setSpotBalance] = useState(0);
  const [whitelist_Data, setWhitelist_Data] = useState([]);
  const [getAmount, setGetAmount] = useState("");
  const [amount, setAmount] = useState(0);
  const [usdtPortfolio, setUsdtPortfolio] = useState(0);
  const [inrPortfolio, setInrPortfolio] = useState(0);
  const [withdraw_amount, setWithdraw_amount] = useState("");

  const [kycStatus, setKycStatus] = useState("");
  const [adminbankdetails, setAdminbankdetails] = useState([]);
  const [inr_amount, setInr_amount] = useState("");

  const [transactionIdError, setTransactionIdError] = useState("");
  const [inrDepositeError, setInrDepositeError] = useState("");
  const [transactionImageError, setTransactionImageError] = useState("");
  const [isWhitelistModalOpen, setIsWhitelistModalOpen] = useState(false);
  const [amountErr, setAmountErr] = useState("");
  const [fees, setFees] = useState();
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [type, setType] = useState("");
  const [percentValue, setPercentValue] = useState("");
  const [inr_amountWithdrawl, setInr_amountWithdrawl] = useState("");
  const [wallet_address, setWallet_address] = useState("");
  const [Currency_name, setCurrency_name] = useState("");
  const [currency_id, setCurrency_id] = useState("");
  const [wallet_currency_amount, setWallet_currency_amount] = useState("");
  const [walletErr, setWalletErr] = useState("");
  const [transferCoinName, setTransferCoinName] = useState("");
  const [transferCoinId, setTransferCoinId] = useState("");
  const [fromWallet, setFromWallet] = useState("");
  const [toWallet, setToWallet] = useState("");
  const [coinAmount, setCoinAmount] = useState("");
  const [coinAmount1, setCoinAmount1] = useState("");
  const [Status, setStatus] = useState(false);
  const [tableData1, setTableData1] = useState([]);
  const [IdentityPic3, setIdentityPic3] = useState(false);
  const [trNumber, setTrNumber] = useState("");
  const [confirmInrBtn, setConfirmInrBtn] = useState("none");
  const [useruploadInrImage, setUseruploadInrImage] = useState("");
  const [inrImage, setInrImage] = useState("/assets/img/icon2.png");
  const [showCurrName, setShowCurrName] = useState("");
  const [chainType, setChainType] = useState("");
  const [withEditData, setWithEditData] = useState(null);
  const [inrDepoModelOpen, setInrDepoModelOpen] = useState(false);
  const [isInrWithdrawOpen, setIsInrWithdrawOpen] = useState(false);

  const { data: userBalance, refetch } = useTransUserBalanceListQuery();

  const BtcAddressQr =
    // "http://chart.googleapis.com/chart?chs=225x225&chld=L|2&cht=qr&chl="
    // "https://qrcode.tec-it.com/API/QRCode?data="
    "https://image-charts.com/chart?chs=150x150&cht=qr&chl=" + wallet_address;
  const BTCencoded = encodeURI(BtcAddressQr);

  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }

    socket.on("connect", () => {
      console.log("Socket connected");
    });
    socket.emit("get-portfolio");

    socket.on("portfolio", (data) => {
      setUsdtPortfolio(data);
    });

    socket.on("deposit", (data) => {
      console.log("Deposit event received:", data);
      refetch();
    });

    socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    return () => {
      socket.off("connect");
      socket.off("portfolio");
      socket.off("disconnect");
      socket.off("connect_error");
    };
  }, []);

  const closeOpenINRDepositModal = () => {
    setIsINRDepositModelOpen(false);
    setUseruploadInrImage("");
    setConfirmInrBtn("none");
    setDepositeInrBtn("block");
    setTrNumber("");
    setInr_amount("");
    setDisabledInrDeposit(false);
    setTransactionIdError("");
    setTransactionImageError("");
    setInrDepositeError("");
    setInrDepoModelOpen(false);
  };

  const portfolioData = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    };

    axios
      .post(baseUrl + "/frontapi/walletTotalBalance", {}, config)
      .then((res) => {
        var resp = res.data;
        setUsdtPortfolio(resp.data[0].USDT);
        setInrPortfolio(resp.data[0].INR);
      });
  };

  const OpenDepositModel = (getCoinName, show_wallet_address, chain_type) => {
    if (kycStatus === "N") {
      toast.error("Please complete your kyc first");
      return false;
    }

    // if (this.state.kycStatus !== "Y") {
    //   setIsKycModalOpen(true);
    //   return false;
    // }
    setShowCurrName(getCoinName);
    setChainType(chain_type);

    if (getCoinName === "INR") {
      setIsINRDepositModelOpen(true);
      setWallet_address(show_wallet_address);
    } else {
      setIsDepositModelOpen(true);
      setWallet_address(show_wallet_address);
    }
  };

  const OpenWithdrawalModel = (
    Currency_name,
    wallet_currency_amount,
    currency_id,
    fees,
    min,
    max,
    type
  ) => {
    if (kycStatus === "N") {
      toast.error("Please complete your kyc first");
      return false;
    }

    if (currency_id == 36) {
      kycStatus === "N" || kycStatus === undefined || kycStatus === null
        ? setIsWithdrawalModelOpen(false)
        : setIsWithdrawalModelOpen(true);

      setGetCoinName_withdrawl(true);
    }

    setIsDepositModelOpen(false);
    setIsWithdrawalModelOpen(true);
    setWhitelist_Data([]);

    setCurrency_name(Currency_name);
    setWallet_currency_amount(wallet_currency_amount);
    setCurrency_id(currency_id);
    setFees(fees);
    setMin(min);
    setMax(max);
    setType(type);

    let LoginData = {
      coin_id: currency_id,
    };

    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    };
    axios
      .post(baseUrl + "/frontapi/whitelistDataById", LoginData, config)
      .then((res) => {
        var resp = res?.data;
        if (resp?.status === true) {
          setWhitelist_Data(resp?.data);
          setWithdraw_address(resp?.data[0]?.whitelistAddress);
        } else {
          setWhitelist_Data([]);
          setWithdraw_address(resp?.data[0]?.whitelistAddress);
        }
      });
  };

  const autoAmount = (e) => {
    if (balanceOfAmount) {
      setAmount(balanceOfAmount);
    } else {
      setAmount("");
    }
  };

  const closeWithdrawalModal = () => {
    setIsWithdrawalModelOpen(false);
    setIsInrWithdrawOpen(false);
    setWithEditData(null);
    refetch();
  };

  const OpenTransferModel = (
    transferCoinName,
    transferCoinId,
    spotBalance,
    walletBalance
  ) => {
    console.log();
    setIsTransferModelOpen(true);
    setTransferCoinName(transferCoinName);
    setTransferCoinId(transferCoinId);
    setWalletBalanceAmount(walletBalance);
    setSpotBalance(spotBalance);
    setAmount("");
  };

  const closeTransferModal = () => {
    setIsTransferModelOpen(false);
    setBalanceOfAmount(0);
    setBalanceOfAmountSpot(0);
    setFromWallet("");
    setToWallet("");
    setAmount("");
  };

  const exchangeValue = () => {
    setBalanceOfAmount(balanceOfAmountSpot);
    setBalanceOfAmountSpot(balanceOfAmount);
    setFromWallet(toWallet);
    setToWallet(fromWallet);
    setCoinAmount("");
    setCoinAmount1("");
  };

  const WalletAllCoinBalance = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
      },
    };
    axios
      .get(baseUrl + "/frontapi/wallet_Coin_Total_Balance", config)
      .then((res) => {
        var resp = res.data;

        setStatus(resp.status);
        setTableData1(resp.data);
      });
  };

  const showTableHtml = () => {
    if (!userBalance?.data?.length) return null;
    let filteredData = userBalance.data;
    if (hideZeroBalance) {
      filteredData = filteredData.filter(
        (item) =>
          parseFloat(item.wallet_balance) > 0 ||
          parseFloat(item.spot_balance) > 0
      );
    }
    if (!filteredData.length) return null;
    return (
      <tbody className="main">
        {filteredData.map((value, i) => {
          const {
            currency_id,
            wallet_balance,
            spot_balance,
            chain_type,
            coin_icon,
            symbol,
            is_deposit,
            is_withdraw,
          } = value;

          const walletAddress = null; // to be fetched if needed

          return (
            <tr key={currency_id || i}>
              <td className="tl">
                {/* {coin_icon ? (
                <img
                  src={`${baseUrl}/static/currencyImage/${coin_icon}`}
                  alt="coin_icon"
                  className="currency_icon"
                />
              ) : (
                <img className="currency_icon" src="/assets/img/btc.png" alt="coin_icon" />
              )} */}
                <img
                  className="currency_icon"
                  // src={baseUrl + "/static/currencyImage/" + item.currency_image}
                  src={`${imageUrl}/images/${symbol?.toLowerCase()}.svg`}
                  // src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${item.pair.split('/')[0].toLowerCase()}.svg`}
                  onError={(e) =>
                    (e.target.src =
                      "https://dummyimage.com/40x40/cccccc/000000.png&text=ven")
                  }
                />

                <small className="ml-1">{symbol}</small>
              </td>

              <td>{Decimal_util.fixedtillString(wallet_balance, 8) || 0}</td>
              <td>{Decimal_util.fixedtillString(spot_balance, 8) || 0}</td>
              {/* <td>{wallet_balance || 0}</td>
              <td>{spot_balance || 0}</td> */}

              <td>
                <div className="four_btn">
                  <button
                    className="btn btn_man fs14 mr-3"
                    onClick={() => {
                      if (symbol == "INR") {
                        setInrDepoModelOpen(true);
                      } else {
                        OpenDepositModel(walletAddress, chain_type, symbol);
                      }
                    }}
                    disabled={is_deposit == 0}
                  >
                    Deposit
                  </button>

                  <button
                    className="btn btn_man fs14 mr-3"
                    onClick={() => {
                      if (userBalance.kyc_status == 0) {
                        toast.dismiss();
                        toast.error("Please complete your kyc first");
                        return;
                      }
                      setWithEditData(value);
                      if (symbol === "INR") {
                        setIsInrWithdrawOpen(true);
                      } else {
                        setIsWithdrawalModelOpen(true);
                      }
                    }}
                    disabled={is_withdraw == 0}
                  >
                    Withdrawal
                  </button>

                  <button
                    className="btn btn_man fs14 mr-3"
                    onClick={() =>
                      OpenTransferModel(
                        symbol,
                        currency_id,
                        Decimal_util.fixedtillString(spot_balance, 8) || 0,
                        Decimal_util.fixedtillString(wallet_balance, 8) || 0
                      )
                    }
                  >
                    Transfer
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };

  const handleChange = (event) => {
    let { name, value } = event.target;
    $("input[type=number]").on("mousewheel", function (e) {
      $(e.target).blur();
    });
    // if (name !== "amount") {
    //   setAmount(value);
    // }

    if (value > 0) {
      setAmountErr("");
    }

    if (name === "amount") {
      let newValue = value;

      const parts = newValue.split(".");

      if (parts[0].length > 8) {
        parts[0] = parts[0].substring(0, 8);
      }

      if (parts[1] && parts[1].length > 8) {
        parts[1] = parts[1].substring(0, 8);
      }

      newValue = parts.join(".");

      if (!newValue || newValue == 0) {
        setAmount(newValue);
        return false;
      }
      setAmount(newValue);
    }

    if (name === "fromWallet") {
      setFromWallet(value);
      if (event.target.value === "wallet") {
        setBalanceOfAmount(walletBalanceAmount);
        setBalanceOfAmountSpot(spotBalance);
        setToWallet("transactions");
      }
      if (event.target.value === "transactions") {
        setBalanceOfAmount(spotBalance);
        setBalanceOfAmountSpot(walletBalanceAmount);
        setToWallet("wallet");
      }
    }
    if (name === "toWallet") {
      setToWallet(value);
      if (event.target.value === "wallet") {
        setBalanceOfAmountSpot(walletBalanceAmount);
        setBalanceOfAmount(spotBalance);
        setFromWallet("transactions");
      }
      if (event.target.value === "transactions") {
        setBalanceOfAmountSpot(spotBalance);
        setBalanceOfAmount(walletBalanceAmount);
        setFromWallet("wallet");
      }
    }

    if (name === "withdraw_amount" || name === "inr_amountWithdrawl") {
      let newValue = value;

      const parts = newValue.split(".");

      if (parts[0].length > 8) {
        parts[0] = parts[0].substring(0, 8);
      }

      if (parts[1] && parts[1].length > 8) {
        parts[1] = parts[1].substring(0, 8);
      }

      newValue = parts.join(".");

      setInr_amountWithdrawl(newValue);
      setWithdraw_amount(newValue);

      setGetAmount("");
      setPercentValue("");
      if (!newValue) {
        setAmountErr("Please enter amount required");
        return false;
      }

      if (newValue <= 0) {
        var withdrawalError = "Please enter valid amount";
        setAmountErr(withdrawalError);
        return false;
      }

      if (newValue <= parseFloat(fees)) {
        setAmountErr("Amount should be greater than withdrawal fees");
        return false;
      }

      setAmountErr("");

      // const amountFees =
      //   parseFloat(newValue) * (100 / (100 + parseFloat(fees)));

      const amountFees = parseFloat(fees);

      // var percentValue = (parseFloat(newValue) * parseFloat(fees)) / 100;
      const calculatedValue = parseFloat(newValue) - parseFloat(amountFees);
      setPercentValue(amountFees);
      setGetAmount(calculatedValue);
    }
  };

  const handleCheckChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    setHideZero(value);
  };

  const handleTransfer = (event) => {
    event.preventDefault();

    if (!fromWallet || !toWallet) {
      toast.error("Please select transfer wallet type");
      return false;
    }
    if (!amount) {
      toast.error("Amount field is required");
      return false;
    }

    const config = {
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
        "Content-Type": "application/json",
      },
    };

    let requestData = {
      from: fromWallet == "transactions" ? "spot" : "wallet", // matches "from" in curl
      to: toWallet == "transactions" ? "spot" : "wallet", // matches "to" in curl
      currency_id: transferCoinId, // coin ID
      amount: parseFloat(amount), // ensure number type
    };

    setDisableTransferButton(true);
    setTimeout(() => setDisableTransferButton(false), 1000);

    axios
      .post(
        `${baseUrl}/transaction/raise-transfer-request`,
        requestData,
        config
      )
      .then((res) => {
        const resp = res.data;

        setAmount("");
        setBalanceOfAmount(0);
        setBalanceOfAmountSpot(0);
        setFromWallet("");
        setToWallet("");

        if (resp.status === true) {
          WalletAllCoinBalance();
          portfolioData();
          toast.dismiss();
          toast.success(resp.message);
          setIsTransferModelOpen(false);
          refetch();
        } else {
          toast.dismiss();
          toast.error(resp.message || "Transfer request failed");
        }
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const handleValidation = (event) => {
    if (event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
    if (
      event.key === "-" ||
      event.key === "+" ||
      event.key === "!" ||
      event.key === "@" ||
      event.key === "#" ||
      event.key === "$" ||
      event.key === "%" ||
      event.key === "^" ||
      event.key === "&" ||
      event.key === "*" ||
      event.key === "(" ||
      event.key === ")"
    ) {
      event.preventDefault();
    }
  };

  const handleClose = () => {
    setIsDepositModelOpen(false);
    refetch();
  };

  return (
    <DocumentMeta {...meta}>
      <div className="">
        <LoginHeader />

        <WithdrawalModal
          open={isWithdrawalModelOpen}
          onClose={closeWithdrawalModal}
          editData={withEditData}
        />

        {/* Transfer Modal Start */}
        <Modal
          show={isTransferModelOpen}
          onHide={closeTransferModal}
          className="account-popup-outer"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title> Transfer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row align-items-center mb-3">
              <div className="form-group col mb-0">
                <label className="mb-0 d-block">Sender </label>

                {toWallet == "wallet" ? (
                  <select
                    className="form-control"
                    name="fromWallet"
                    value={fromWallet}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="transactions">Spot</option>
                  </select>
                ) : toWallet == "transactions" ? (
                  <select
                    className="form-control"
                    name="fromWallet"
                    value={fromWallet}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="wallet">Wallet</option>
                  </select>
                ) : (
                  <select
                    className="form-control"
                    name="fromWallet"
                    value={fromWallet}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="transactions">Spot</option>
                    <option value="wallet">Wallet</option>
                  </select>
                )}
                <span> balance : {balanceOfAmount}</span>

                <small>{coinAmount}</small>
              </div>
              <div className="form-group col directions_35_OP pr-0 pl-0 mb-0">
                <span onClick={exchangeValue}>
                  <i className="las la-exchange-alt"></i>
                </span>
              </div>
              <div className="form-group col mb-0">
                <label className="mb-0 d-block">Receiver</label>

                {fromWallet == "wallet" ? (
                  <select
                    className="form-control"
                    name="toWallet"
                    value={toWallet}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="transactions">Spot</option>
                  </select>
                ) : fromWallet == "transactions" ? (
                  <select
                    className="form-control"
                    name="toWallet"
                    value={toWallet}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="wallet">Wallet</option>
                  </select>
                ) : (
                  <select
                    className="form-control"
                    name="toWallet"
                    value={toWallet}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="transactions">Spot</option>
                    <option value="wallet">Wallet</option>
                  </select>
                )}
                <span> balance : {balanceOfAmountSpot}</span>
                <small>
                  {coinAmount1}
                  {/* {coinName1} */}
                </small>
              </div>
            </div>
            <div className="form-group">
              <label className="mb-0">Coin</label>
              <div className="form-control">{transferCoinName}</div>{" "}
            </div>
            <div className="relative">
              <div className="form-group">
                <label className="mb-0">Amount</label>
                <input
                  // value="0"
                  step="any"
                  className="form-control"
                  name="amount"
                  value={amount}
                  onChange={handleChange}
                  placeholder="Enter Amount"
                  type="number"
                  onKeyDown={handleValidation}
                />
                <button
                  className="absolute_btc max-btn btn btn_man fs14"
                  onClick={autoAmount}
                >
                  Max
                </button>
              </div>
            </div>
            <div className="tc">
              <button
                className="btn btn_man fs14"
                onClick={handleTransfer}
                disabled={disableTransferButton}
              >
                Transfer
              </button>
            </div>
          </Modal.Body>
        </Modal>
        {/* Transfer Modal End */}

        {/* CoinList Html Part Start */}
        <div className="bghwhite">
          <div className="dashbord_manbox zero-balance-outer">
            <div className="container container2">
              <div className="dashbord_in1">
                <div className="dashbord_in ">
                  <div className="row align-items-center">
                    <div className="col-md-4 col-12">
                      <div className=" form-check">
                        <label className="form-check-label">
                          <input
                            name="hideZeroBalance"
                            type="checkbox"
                            checked={hideZeroBalance}
                            onChange={handleCheckChange}
                          />{" "}
                          Hide zero balances wallet
                        </label>
                      </div>
                    </div>
                    <div className="col-md-8 col-12">
                      <div className="portfolio-amount d-flex justify-content-end align-items-center">
                        <p className="m-0">Portfolio :</p>

                        {/* END */}
                        <div className="amount-inner d-flex">
                          {/* <div className="amount-left">
                          <p className="mb-0">
                            <b>{parseFloat(inrPortfolio)}</b> INR{" "}
                          </p>
                        </div>{" "} */}
                          <div className="amount-right ml-2">
                            <p className="m-0">
                              <b> {parseFloat(usdtPortfolio)}</b> USDT
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="amount-tabel-main-outer">
                    <div className="in_table tc border_man">
                      <div className="table-responsive">
                        <table className="table mb-0 table_man table-striped">
                          <thead>
                            <tr>
                              <th className="tl">
                                <b>Coin</b>
                              </th>
                              <th>
                                <b>Main - Wallet</b>
                              </th>
                              <th>
                                <b>SPOT - Wallet</b>
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          {showTableHtml()}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CoinList Html Part End */}

        <INRDepositModel
          onClose={closeOpenINRDepositModal}
          open={inrDepoModelOpen}
        />

        <INRWithdrawModal
          open={isInrWithdrawOpen}
          onClose={closeWithdrawalModal}
          editData={withEditData}
        />
      </div>
      <DepositModal
        show={isDepositModelOpen}
        chainType={chainType}
        onClose={handleClose}
      />
    </DocumentMeta>
  );
};

export default AccountFunction;
